import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import classNames from "classnames/bind";
import styles from "./CodeBlock.module.scss";

const cx = classNames.bind(styles);

function CodeBlock({ language = "javascript", style = oneDark, code }) {
  return (
    <div className={cx("wrapper")}>
      <SyntaxHighlighter language={language} style={{ ...style, background: "none" }}>
        {code}
      </SyntaxHighlighter>
    </div>
  );
}

export default CodeBlock;
